import { api } from '@/core/api/';
import academicYearService from '@/modules/common/academicyear.api';

const apiUrl = 'api/periodEnd';
export default {
  async getAcademicYears() {
    return academicYearService.getRegistryVisit();
  },
  async getMonths(academicYear) {
    let { data } = await api
      .get(`${apiUrl}/months/${academicYear.id}`)
      .catch(() => {
        return [];
      });

    const mappedMonths = data.map((item) => {
      return {
        id: item.monthDesc,
        selected: false,
        disabled: false,
        isDirty: false,
        name: item.monthDesc,
        sortOrder: 0,
        monthNumber: item.monthNumber,
        year: item.year,
      };
    });

    return {
      months: data,
      mappedMonths,
    };
  },
  async getSpecialists(academicYearId, monthNumber, payload) {
    return await api.get(
      `${apiUrl}/specialists/${academicYearId}/${monthNumber}`,
      {
        params: {
          ...payload,
        },
      }
    );
  },
  async searchPeriodEndSummary(payload) {
    return await api.get(`${apiUrl}/searchperiodendsummary`, {
      params: {
        ...payload,
      },
    });
  },
  async finalizePeriod(payload) {
    return await api.get(`${apiUrl}/finalizeperiod`, {
      params: {
        ...payload,
      },
    });
  },
  async startEndedPeriod(payload) {
    return await api.get(`${apiUrl}/startperiodsummaryvalidation`, {
      params: {
        ...payload,
      },
    });
  },
  async getCenters(academicYearId, monthNumber, payload) {
    return await api.get(`${apiUrl}/centers/${academicYearId}/${monthNumber}`, {
      params: {
        ...payload,
      },
    });
  },
  async getProviders(academicYearId, payload) {
    return await api.get(`${apiUrl}/providers/${academicYearId}`, {
      params: {
        ...payload,
      },
    });
  },

  async getServices(payload) {
    return await api.get(`${apiUrl}/services`, {
      params: {
        ...payload,
      },
    });
  },
};
